import React from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import queryClient from 'react-query-settings/queryClient';

import AppWrapper from 'components/apps/AppWrapper';
import { ProjectCoshhContext } from 'components/contexts/ProjectCoshhContext';
import ProjectCoshhTab from 'components/projectCoshh/components/ProjectCoshhTab';

export default function EntryPoint({ contextProps, wrappedProps }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AppWrapper {...contextProps}>
        <ProjectCoshhContext.Provider value={{ ...wrappedProps }}>
          <ProjectCoshhTab />
        </ProjectCoshhContext.Provider>
      </AppWrapper>
    </QueryClientProvider>
  );
}

EntryPoint.propTypes = {
  wrappedProps: PropTypes.shape({
    comparisonValueForCustomValueUsage: PropTypes.string.isRequired,
    coshhPolicy: PropTypes.shape({
      canCreate: PropTypes.bool.isRequired,
      canDestroy: PropTypes.bool.isRequired,
      canUpdate: PropTypes.bool.isRequired,
    }).isRequired,
    isMsdsIncluded: PropTypes.bool.isRequired,
    isProjectIncomplete: PropTypes.bool.isRequired,
    projectId: PropTypes.string.isRequired,
    secondaryFieldPlaceholder: PropTypes.string.isRequired,
  }).isRequired,
};
